module.exports = __webpack_public_path__ + "static/media/61992ac3-1582-4b76-9057-2e219552f837-3.a3613ae4.woff";